module.exports = __webpack_public_path__ + "img/界面展示2.89694fe5.png";